import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {BasicStateReelSymbol} from "../symbols/BasicStateReelSymbol";

/**
 * H3 Will Prevail (2018-08-13).
 */


export class TractorBeamReelStopPresentation extends ReelStopPresentationController {
    private _mode:string;

    private _nextMode:string

    constructor(index:number) {
        super(index, "TractorBeamReelStopPresentation")
    }


    protected parseFeatureGameData(data:TractorBeamParsedGameData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:SpinEvent) => this.onBeforeSpinStart());
    }


    public onReelBounce(data:IReelStoppedData):void {
        // Do bounce on all syms
        // Add bounce animation
        [0, 1, 2].forEach((symId) => {
            const symbol:BasicStateReelSymbol | null = <BasicStateReelSymbol>Reels.getSymbol(data.reelId, symId);

            if(symbol && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(symbol.symName) > -1) {
                symbol.playSpineAnimation(symbol.symName, symbol.symName + "-spinEnd", false, 1, (trackEntry:PIXI.spine.core.TrackEntry) => {
                    if(trackEntry.animation.name === symbol.symName + "-spinEnd") {
                        if(symbol.symName === "S") {
                            symbol.playSpineAnimation(symbol.symName, symbol.symName + "-idle", true, 0.65);
                        } else {
                            symbol.playSpineAnimation(symbol.symName, symbol.symName + "-idle", true, 0.3);
                        }
                    }
                });
                //this.bounceSymbol(symbol);
            } else if(symbol && symbol.symName.indexOf("L") < 0) {
                this.bounceSymbol(symbol);
            }
        });

        this.getSymbolOutsideReel(data.reelId);
    }


    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }

    protected bounceSymbol(sym:StateReelSymbol, duration:number = 0.3):Timeline {
        const timeline:Timeline = new TimelineMax();
        const time:number = duration / 5;

        timeline.add(TweenLite.to(sym.scale, time, {
            x : 1.1,
            y : .7
        }));

        timeline.add([
            TweenLite.to(sym.scale, time * 2, {x : 0.9, y : 1.1})
        ]);

        timeline.add([
            TweenLite.fromTo(sym.scale, time * 2, {
                x : 0.9,
                y : 1.1
            }, {
                x : 1,
                y : 1
            })
        ]);


        return timeline;
    }


    protected resetFeature():void {

    }

    private getSymbolOutsideReel(reelId:number) {
        const symbolAbove = Reels.getSymbol(reelId, -1);
        const symbolBelow = Reels.getSymbol(reelId, 3);

        if(symbolAbove && symbolBelow) {
            this.fadeOutSym(symbolAbove, symbolBelow);
        }
    }

    private onBeforeSpinStart():void {
        [0, 1, 2, 3, 4].forEach((reelId:number) => {
            const symbolAbove:BasicStateReelSymbol = <BasicStateReelSymbol>Reels.getSymbol(reelId, -1);
            const symbolBelow:BasicStateReelSymbol = <BasicStateReelSymbol>Reels.getSymbol(reelId, 3);

            if(symbolAbove && symbolBelow) {
                this.fadeInSym(symbolAbove, symbolBelow);

                // start spin
                symbolAbove.playSpineAnimation(symbolAbove.symName, symbolAbove.symName + "-spinStart", false);
                symbolBelow.playSpineAnimation(symbolBelow.symName, symbolBelow.symName + "-spinStart", false);

            }

        });
    }

    private fadeOutSym(symbol:StateReelSymbol, symbol2?:StateReelSymbol):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(!symbol2) {
            tl.add([
                new TweenLite(symbol, 0.2, {alpha : 0})
            ]);
        } else {
            tl.add([
                new TweenLite(symbol, 0.2, {alpha : 0}),
                new TweenLite(symbol2, 0.2, {alpha : 0})
            ]);
        }

        return tl;
    }

    private fadeInSym(symbol:StateReelSymbol, symbol2:StateReelSymbol):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            new TweenLite(symbol, 0.1, {alpha : 1}),
            new TweenLite(symbol2, 0.1, {alpha : 1})
        ]);

        return tl;
    }
}
